import React from 'react';
import { environment } from '../../environments/environment';
import axios from 'axios';
import { COMPLIANCE_URL } from '../../constants/backendUrl';

export class ComplianceServices {
  private static URL: any = environment.partnerApiUrl;

  public static addComplince(data: any) {
    // let UserURL: string = `${this.URL}/complince`;
    let UserURL: string = `${this.URL}/${COMPLIANCE_URL.addcompliance}`;


    const config = {
      headers: { Authorization: `Bearer ${sessionStorage.getItem("Token")}` },
    };
    return axios.post<any>(UserURL, data, config);
  };

    public static GetComplianceall(partnerid: number,pagenumber:any) {

      let UserURL: string = `${this.URL}/${COMPLIANCE_URL.getComplianceList}?PartnerId=${partnerid}&Pagenumber=${pagenumber}`;
  
      const config = {
        headers: { Authorization: `Bearer ${sessionStorage.getItem("Token")}` },
      };
      return axios.get<any>(UserURL, config);
    };
}

export default ComplianceServices;
